/**
 * How close a ticket is to leaving the Google feed. A ticket leaves the feed on
 * its last valid day, so the page warns ahead of time and names the day.
 */

export const ENDS_SOON_DAYS = 30

export type TicketValidity =
    | { state: 'open' }
    | { state: 'ok'; validTo: Date }
    | { state: 'endsSoon'; validTo: Date; daysLeft: number }
    | { state: 'ended'; validTo: Date }

const DAY_MS = 24 * 60 * 60 * 1000

const startOfDay = (date: Date): number => new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()

export function ticketValidity(validTo: Date | null, today: Date = new Date()): TicketValidity {
    if (!validTo) {
        return { state: 'open' }
    }
    const daysLeft = Math.round((startOfDay(validTo) - startOfDay(today)) / DAY_MS)
    if (daysLeft < 0) {
        return { state: 'ended', validTo }
    }
    if (daysLeft <= ENDS_SOON_DAYS) {
        return { state: 'endsSoon', validTo, daysLeft }
    }
    return { state: 'ok', validTo }
}
